// Componente modal de confirmación tipo material
// Uso: window.showConfirmDialog({ message, onConfirm, onCancel })

const template = document.createElement("template");
template.innerHTML = `
  <div id="backdrop" class="fixed inset-0 bg-black/40 flex items-center justify-center z-50 hidden">
    <div class="bg-white rounded-xl shadow-2xl max-w-sm w-full p-6 flex flex-col items-center animate-fade-in">
      <div class="w-12 h-12 flex items-center justify-center rounded-full bg-red-100 mb-4">
        <svg class="w-6 h-6 text-red-600" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>
      </div>
      <div id="dialog-message" class="text-gray-800 text-center mb-6 text-lg font-medium"></div>
      <div class="flex gap-4 w-full justify-center">
        <button id="cancel-btn" class="px-3 py-1.5 rounded bg-gray-200 text-gray-700 hover:bg-gray-300 font-medium transition text-sm">Cancelar</button>
        <button id="confirm-btn" class="px-3 py-1.5 rounded bg-red-600 text-white hover:bg-red-700 font-medium transition text-sm">Sí, eliminar</button>
      </div>
    </div>
  </div>
`;

document.body.appendChild(template.content.cloneNode(true));

window.showConfirmDialog = function ({ message, onConfirm, onCancel }) {
  const backdrop = document.getElementById("backdrop");
  const msg = document.getElementById("dialog-message");
  const confirmBtn = document.getElementById("confirm-btn");
  const cancelBtn = document.getElementById("cancel-btn");
  msg.textContent = message;
  backdrop.classList.remove("hidden");

  function cleanup() {
    backdrop.classList.add("hidden");
    confirmBtn.removeEventListener("click", confirmHandler);
    cancelBtn.removeEventListener("click", cancelHandler);
  }
  function confirmHandler() {
    cleanup();
    if (onConfirm) onConfirm();
  }
  function cancelHandler() {
    cleanup();
    if (onCancel) onCancel();
  }
  confirmBtn.addEventListener("click", confirmHandler);
  cancelBtn.addEventListener("click", cancelHandler);
};
